export default __webpack_public_path__ + "static/media/pattern1.e0ddd8d4.svg";